/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCopyFieldTo = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 1H2v6h20V1zm-2 4H4V3h16v2zm-1.3 10.7 3.7-3.7-3.7-3.7-1.4 1.4 1.3 1.3H14v2h4.6l-1.3 1.3zM12 13H4v-2h8V9H2v6h10zM2 23h20v-6H2v6zm2-4h16v2H4v-2z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgCopyFieldTo as CopyFieldTo };
